export default "__VITE_PUBLIC_ASSET__32dcd9f0__"